export class LoadStandings {
  static readonly type = '[Standings] Load standings';

  constructor(readonly groupId: string) {}
}
